<style scoped>
    .tags-view {
        position: relative;
        width:100%;
        z-index:100;
        height: 36px;
        background: #eaedf1;
        user-select:none;
        border-bottom: 1px solid #d7def3;
    }
    .tags-view .tags-view-wrapper {
        height: 35px;
    }
    .tags-view li {
        position: relative;
        z-index: 2;
        bottom: -1px;
        padding: 0 30px 0 10px;
        list-style: none;
        display: inline-block;
        margin-top: 3px;
        margin-left: 2px;
        cursor: pointer;
        height: 32px;
        line-height: 32px;
        border-radius: 6px 6px 0 0;
        border: 1px solid #d7def3;
        font-size: 14px;
        color: #333744;
    }
    .tags-view li.cur{
        background: #fff;
        border-bottom: none;
        color: rgb(40,110,214);
        font-weight: bold;
    }
    .tags-view li span {
        position: absolute;
        right: 6px;
        top: 10px;
        width: 13px;
        height: 13px;
        /*background: url(../../assets/icon/cuo.png) no-repeat;*/
    }
    .tagscuocls {
        background: url(../../assets/icon/cuo.png) no-repeat;
    }

    .tagschacls {
        background: url(../../assets/icon/cha.png) no-repeat;
    }
    .tagsdivcls {
        height: 5px;
        width: calc(100% + 0px);
        background-color: rgb(40, 110, 214);
        margin-left: -10px;
        border-radius: 6px 6px 0 0;
        position: absolute;
    }

    .homecls{
        padding: 0 20px 0 10px !important;
    }
    .contextmenu{
        margin: 0;
        background: #fff;
        z-index: 100;
        position: absolute;
        list-style: none;
        padding: 5px 0;
        border-radius: 4px;
        font-size: 12px;
        font-weight: 400;
        color:#333;
        box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, .3);
    }
    .contextmenu li {
        margin: 0;
        padding: 1px 16px;
        cursor: pointer;
        display: block;
        line-height: 20px;
    }
    .contextmenu li:hover{
        background: #eee;
    }

</style>
<template>
    <div class="tags-view" v-if="componentShow">
        <scroll-pane class="tags-view-wrapper" ref="scrollPane">
            <ul ref="tagUl">
                <router-link tag="li" ref="tag"
                             v-for="item in tagsMenu"
                             :to="item"
                             :key="item.meta.tabName"
                             @contextmenu.prevent.native="openMenu(item,$event)"
                             :class="{'cur': $route.meta.tabName === item.meta.tabName,'homecls' : item.meta.tabName == 'home'}">
                    <div class="tagsdivcls" v-if="$route.meta.tabName === item.meta.tabName"></div>
                    <img v-if="item.meta.tabName == 'home'" src="../../assets/icon/shouye.png" />
                    {{$t("menu."+item.meta.tabName)}}
                    <span v-if="item.meta.tabName !== 'home'" :class="{'tagschacls' : $route.meta.tabName === item.meta.tabName,'tagscuocls':$route.meta.tabName !== item.meta.tabName}" @click.prevent.stop='closeSelectedTag(item)'></span>
                </router-link>
            </ul>
        </scroll-pane>
        <ul v-show="visible" :style="{left: left+'px', top: top+'px'}" class="contextmenu">
            <li @click="closeOthersTags">{{$t(i18nPage+'关闭其他')}}</li>
            <li @click="closeAllTags">{{$t(i18nPage+'关闭所有')}}</li>
        </ul>
    </div>
</template>
<script type="text/ecmascript-6">
    import {mapGetters} from 'vuex'
    import scrollPane from '../scrollPane'
    export default {
        name: 'TagsView',
        beforeCreate() {
            this.i18nPage = 'component.tagsView.';
        },
        components: {scrollPane},
        computed: {
            ...mapGetters(['tagsMenu']),
        },
        watch: {
            $route(to) {
                this.addViewTags();
                //this.moveToCurrentTag();
                let historical = [], flag = false;
                if (localStorage.getItem("historical")) {
                    historical = JSON.parse(localStorage.getItem("historical"))
                }
                for (const item of historical) {
                    if (item.title === to.meta.tabName) {
                        flag = true;
                        break;
                    }
                }
                if (!flag) {
                    historical.unshift({
                        title: to.meta.tabName,
                        path: to.path,
                        time: new Date().getTime()
                    });
                }
                localStorage.setItem("historical", JSON.stringify(historical));
            },
            visible(value) {
                if (value) {
                    document.body.addEventListener('click', this.closeMenu)
                } else {
                    document.body.removeEventListener('click', this.closeMenu)
                }
            }
        },
        data() {
            return {
                i18nPage : 'component.tagsView.',
                visible: false,
                top: 0,
                left: 0,
                selectedTag: {},
                componentShow:true
            }
        },
        mounted() {
            this.addViewTags()
        },
        methods: {
            generateRoute() {
                if (this.$route.meta.tabName) {
                    return this.$route;
                }
                return false;
            },
            isActive(route) {
                return route.meta.tabName === this.$route.meta.tabName;
            },
            addViewTags() {
                const route = this.generateRoute()
                if (!route) return false;
                this.$store.dispatch('addTagsMenu', route);
            },
            moveToCurrentTag() {
                const tags = this.$refs.tag;
                const tagUl = this.$refs.tagUl;
                this.$nextTick(() => {
                    for (const tag of tags) {
                        if (tag.to.path = this.$route.path) {
                            this.$refs.scrollPane.moveToTarget(tagUl,tag.$el)
                            break;
                        }
                    }
                })
            },
            closeSelectedTag(tagsMenuItem) {
                this.$store.dispatch('delTagsMenu', tagsMenuItem).then((tagsMenu) => {
                    if (this.isActive(tagsMenuItem)) {
                        //根据时间戳排序
                        let sortMenu = tagsMenu.sort( (a, b) => {
                            return a.index - b.index;
                        });
                        //获取最后活动页签
                        const latestView = sortMenu.slice(-1)[0];
                        //跳转到最后活动页签
                        setTimeout(() => {
                            this.$router.push({path:latestView.path, query: latestView.query});
                        }, 0)
                    }
                })
            },
            closeTagByPath(path){
                if(path){
                    let obj = null;
                    obj = this.tagsMenu.find((item)=>{
                        return item.path === path;
                    });
                    if(obj){
                        this.closeSelectedTag(obj);
                    }
                }
            },
            closeOthersTags() {
                // this.$router.push(this.selectedTag)
                this.$store.dispatch('delOthersViews', this.selectedTag).then(() => {
                    // this.moveToCurrentTag()
                    // 如果右键的tag的路由地址 不是当前路由的地址则直接跳转到右键的菜单
                    if(this.$route.fullPath != this.selectedTag.fullPath){
                        this.$router.push(this.selectedTag.fullPath)
                    }
                })
            },
            closeAllTags() {
                this.$store.dispatch('delAllViews');
                this.$router.push('/home')
            },
            openMenu(tag, e) {
                const menuMinWidth=105;
                const offsetLeft = this.$el.getBoundingClientRect().left;
                const offsetWidth = this.$el.offsetWidth;
                const maxLeft = offsetWidth - menuMinWidth
                const left = e.clientX - offsetLeft + 15;
                if (left > maxLeft) {
                    this.left = maxLeft
                } else {
                    this.left = left
                }
                this.top = e.clientY - 50

                this.visible = true;
                this.selectedTag = tag
            },
            closeMenu() {
                this.visible = false
            }
        },
        beforeDestroy(){
            this.componentShow = false;
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/tagsView/index.vue